module.exports = __webpack_public_path__ + "img/home.ecc1df56.svg";